:host {
  display: inline-block;
}

.loader {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(52, 52, 52, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 300ms var(--o2-transition);
  z-index: 99999999;
  pointer-events: all;
  visibility: hidden;
  opacity: 0;

  o2-icon[name='loading'] {
    animation-iteration-count: infinite;
    animation-timing-function: var(--o2-transition);
    animation-name: icon--rotate;
    animation-duration: 1350ms;
    width: auto;
    height: 100%;
    max-height: 8rem;
  }

  &.loader--visible {
    visibility: visible;
    opacity: 1;

    &.loader--body-child {
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 99999999;
    }
  }

  &.loader--body-child {
    position: fixed;
  }
}

@keyframes icon--rotate {
  0% {
    transform: rotate(0deg);
  }

  75% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
